const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'CONTRATO_ITEM_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'CONTRATO_ITEM_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'CONTRATO_ITEM_LISTADO':
            return {
                ...state, 
                lista: action.payload.data
            };

        default:
            return state;
    }
}
